<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-form
        ref="formSearch" :model="queryForm" label-position="top"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item>
              <template slot="label">
                <div class="selectLabel">{{ $t('tablePrice.riderClosedLoopTime') }}</div>
              </template>
              <el-date-picker
                v-model="queryDateTime"
                :end-placeholder="$t('operationCenter.endDate')"
                :picker-options="pickerOptions"
                :start-placeholder="$t('operationCenter.startDate')"
                range-separator="~"
                style="width: 100%"
                type="daterange"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
          <!-- 所属州 -->
          <el-col :span="4">
            <el-form-item :label="$t('tablePrice.riderState')">
              <el-select
                v-model="queryForm.params.regionOrState"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                collapse-tags
                filterable
                multiple
                style="width: 100%"

                @change="handleStateChange"
              >
                <el-option
                  v-for="item in stateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 所属大区 -->
          <el-col :span="4">
            <el-form-item :label="$t('tablePrice.riderRegion')">
              <el-select
                v-model="queryForm.params.regionIds"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                collapse-tags
                filterable
                multiple
                style="width: 100%"
              >
                <!-- 大区label与大区维度一字不差：中文（葡语） -->
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.zhName + '（' + item.puName + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 所属网点 -->
          <el-col :span="4">
            <el-form-item :label="$t('tablePrice.riderSite')">
              <ElSelectV2
                v-model="queryForm.params.stateOrSite"
                :options="siteV2Options"
                clearable
                collapse-tags
                filterable
                multiple
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <!--  投诉来源  -->
            <el-form-item :label="$t('tablePrice.complaintType')">
              <el-select
                v-model="queryForm.params.complaintSource"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in complaintSourceList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <!--  处理结果  -->
            <el-form-item :label="$t('collectionCenter.processingResult')">
              <el-select
                v-model="queryForm.params.processingResult"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in complaintTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div>
              <el-button
                icon="el-icon-search" size="small" type="primary"
                @click="btnSearch(1)"
              >{{ $t('operationCenter.Procurar') }}
              </el-button>
              <el-button icon="el-icon-refresh-left" size="small" @click="btnSearch(2)">
                {{ $t('operationCenter.reset') }}
              </el-button>
              <el-button
                size="small" @click="allExportOrder"
              >{{ $t('newOrder.export') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{ color: 'black' }"
      border
      style="width: 100%"
    >
      <el-table-column :label="$t('tablePrice.rider')" min-width="140" prop="riderName" />
      <el-table-column :label="$t('tablePrice.riderSite')" min-width="120" prop="siteName">
        <template slot-scope="scope">{{ scope.row.siteName || '-' }}</template>
      </el-table-column>
      <el-table-column :label="$t('tablePrice.riderState')" min-width="100" prop="state">
        <template slot-scope="scope">{{ scope.row.state || '-' }}</template>
      </el-table-column>
      <el-table-column :label="$t('tablePrice.riderRegion')" min-width="110" prop="regionName">
        <template slot-scope="scope">{{ scope.row.regionName || '-' }}</template>
      </el-table-column>
      <el-table-column
        :label="$t('tablePrice.deliveryQuantity')" min-width="110" prop="signedCount"
        :formatter="thousandFormat"
      />
      <el-table-column :label="$t('tablePrice.avgDailySigned')" min-width="120" prop="avgDailySigned" />
      <el-table-column
        :label="$t('tablePrice.workOrderCount')" min-width="110" prop="workOrderCount"
        :formatter="thousandFormat"
      />
      <el-table-column
        :label="$t('tablePrice.falseDeliveryQuantity')" min-width="120" prop="falseSignCount"
        :formatter="thousandFormat"
      />
      <el-table-column :label="$t('tablePrice.riderWorkOrderCreateRate')" min-width="130" prop="workOrderCreateRate" />
      <el-table-column :label="$t('tablePrice.confirmRate')" min-width="110" prop="confirmRate" />
      <el-table-column :label="$t('tablePrice.riderFalseSignRate')" min-width="130" prop="falseSignRate" />
    </el-table>
    <div class="pagination">
      <el-pagination
        :current-page.sync="queryForm.pageNumber"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="getSearch()"
        @current-change="getSearch()"
      />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { getLgAreaListData, regionQueryList, selectInfoByStateTwo } from '@/api/orderApi';
import {
  failSignReportExport,
  falseSignDailyReportSitePage,
  falseSignDailyReportSiteSummary,
  getSiteByState
} from '@/api/newExpressAPI';
import { goResourceTaskList } from '@/utils/goExportList';
import { complaintSource, complaintType3 } from '@/utils/enumData';
import { formatNumber } from '@/utils/tools';
import ElSelectV2 from 'el-select-v2';

export default {
  name: 'FalseSignRider',
  components: { ElSelectV2 },
  data() {
    return {
      // 4216 骑手维度：时间筛选=闭环时间窗（工单量/虚假签收量=期内闭环工单，签收量/日均=同期签收，率可>100%产品已认可）
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          type: 3,
          regionOrState: [],
          regionIds: [],
          stateOrSite: [],
          complaintSource: '',
          processingResult: ''
        }
      },
      total: 0,
      tableData: [],
      stateList: [],
      regionList: [],
      siteList: [],
      // ElSelectV2 虚拟下拉 options（{value,label}，只渲染可视区，全量数据不卡）
      siteV2Options: [],
      complaintSourceList: complaintSource,
      complaintTypeList: complaintType3,
      queryDateTime: [this.getAWeek().startDate, this.getAWeek().endDate],
      choiceDate0: '',
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate0 = minDate.getTime();
          if (maxDate) {
            this.choiceDate0 = '';
          }
        },
        disabledDate: (time) => {
          if (this.choiceDate0 !== '') {
            const one = 90 * 24 * 3600 * 1000;
            const minTime = this.choiceDate0 - one;
            const maxTime = this.choiceDate0 + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      }
    };
  },
  created() {
    this.getSearch(1);
    this.getAddress();
    this.getRegion();
    this.getSiteList();
  },
  methods: {
    // 千分位格式化（整数；中文 1,000 / 葡语 1.000），与其它维度量列一致
    thousandFormat(_row, _column, cellValue) {
      return formatNumber(cellValue, 0);
    },
    getAWeek() {
      return {
        endDate: dayjs().format('YYYY-MM-DD'),
        startDate: dayjs().subtract(6, 'day').format('YYYY-MM-DD')
      };
    },
    getAddress() {
      const params = { level: 0, parentId: '' };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.stateList = res.data.map((item) => ({ id: item.id, label: `${item.nameEn}` }));
        }
      });
    },
    getRegion() {
      regionQueryList(1).then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    getSiteList() {
      selectInfoByStateTwo({}).then((res) => {
        if (res.code === 200) {
          this.siteList = res.data.siteList || [];
          this.siteV2Options = this.siteList.map((st) => ({ ...st, value: st.id, label: st.name }));
        }
      });
    },
    // 选州后按州刷新网点选项（与网点维度tab联动行为一致；清空州恢复全量）
    handleStateChange(val) {
      this.queryForm.params.stateOrSite = [];
      if (val && val.length > 0) {
        getSiteByState(val).then((res) => {
          if (res.code === 200) {
            this.siteV2Options = (res.data || []).map((st) => ({ ...st, value: st.id, label: st.name }));
          }
        });
      } else {
        this.siteV2Options = this.siteList.map((st) => ({ ...st, value: st.id, label: st.name }));
      }
    },
    btnSearch(type) {
      if (type === 1) {
        this.queryForm.pageNumber = 1;
        this.getSearch();
      } else {
        this.queryForm = {
          pageSize: 10,
          pageNumber: 1,
          params: {
            type: 3,
            regionOrState: [],
            regionIds: [],
            stateOrSite: [],
            complaintSource: '',
            processingResult: ''
          }
        };
        this.queryDateTime = [this.getAWeek().startDate, this.getAWeek().endDate];
        this.getSearch();
      }
    },
    getSearch(val) {
      const data = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: {
          type: 3,
          regionOrState: this.queryForm.params.regionOrState,
          regionIds: this.queryForm.params.regionIds,
          stateOrSite: this.queryForm.params.stateOrSite,
          startTime: '',
          endTime: '',
          complaintSource: this.queryForm.params.complaintSource,
          processingResult: this.queryForm.params.processingResult
        }
      };
      if (this.queryDateTime && this.queryDateTime.length > 0) {
        data.params.startTime = this.queryDateTime[0];
        data.params.endTime = this.queryDateTime[1];
      } else {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      let loading = null;
      if (val === 1) {
        loading = this.$loading({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
      }
      Promise.all([
        falseSignDailyReportSitePage(data),
        // summary 接口收扁平对象（与 site/region/customer 组件一致），传整个 data 会丢筛选条件
        falseSignDailyReportSiteSummary(data.params)
      ])
        .then(([pageRes, sumRes]) => {
          if (pageRes.code === 200) {
            this.total = pageRes.data.total;
            const records = pageRes.data.records || [];
            // 合计行置顶（与其它维度展示一致）
            this.tableData = sumRes.code === 200 && sumRes.data ? [sumRes.data, ...records] : records;
          }
        })
        .finally(() => {
          if (loading) loading.close();
        });
    },
    allExportOrder() {
      const data = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: {
          type: 3,
          regionOrState: this.queryForm.params.regionOrState,
          regionIds: this.queryForm.params.regionIds,
          stateOrSite: this.queryForm.params.stateOrSite,
          startTime: '',
          endTime: '',
          complaintSource: this.queryForm.params.complaintSource,
          processingResult: this.queryForm.params.processingResult
        }
      };
      if (this.queryDateTime && this.queryDateTime.length > 0) {
        data.params.startTime = this.queryDateTime[0];
        data.params.endTime = this.queryDateTime[1];
      } else {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      failSignReportExport(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    }
  }
};
</script>

<style scoped>
.selectLabel {
  height: 28px !important;
  line-height: 28px !important;
}
.pagination {
  text-align: right;
  margin-top: 10px;
}
</style>
